export function getUserDisplayName(user, fallback = "No Name") {
  const directName = String(
    user?.fullName || user?.displayName || ""
  )
    .trim()
    .replace(/\s+/g, " ");

  if (directName) return directName;

  const username = String(user?.username || "").trim();
  if (username) return username;

  const savedName = String(user?.name || "")
    .trim()
    .replace(/\s+/g, " ");
  if (savedName) return savedName;

  const composedName = [
    user?.firstName,
    user?.middleInitial,
    user?.lastName,
    user?.extension,
  ]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  return composedName || String(user?.email || fallback || "").trim() || fallback;
}
